import {
  ENTITLEMENTS_SUCCESS,
  ENTITLEMENTS_CREATE,
} from '../constants/actions';

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ENTITLEMENTS_SUCCESS:
      return {
        ...state,
        data: action.data,
      };

    case ENTITLEMENTS_CREATE:
      return {
        ...state,
        data: [...state.data, ...action.data],
      };

    default:
      return { ...state };
  }
};
